import { CustomActionDefinition } from '../custom-action-definitions'

export enum RowActionBehaviour {
  Standard = 10,
  Hide = 20,
  OnlyCustom = 30,
}

export interface RowActionsDefinition {
  behaviour: RowActionBehaviour
  actions: CustomActionDefinition[]
}
